module.exports = "/packs/images/pages/content_hub/featured-article~f67b1f5b13b2922f77a639c03f30846d.jpg";